import { useTranslation } from 'react-i18next';
import { formatMoney, formatMoneyCents, localeFromLanguage } from '@/lib/money';

/**
 * Locale-bound money formatters for Commerce. Reads the active i18n language and
 * returns `moneyCents` / `money` pre-bound to the right BCP-47 locale, so call
 * sites only pass `(amount, currency)`. The resource currency must still be
 * passed — the locale only controls grouping and symbol placement.
 */
export function useMoney() {
  const { i18n } = useTranslation();
  const locale = localeFromLanguage(i18n.language);

  return {
    locale,
    /** Format a MINOR-unit (cents) amount under the resource currency + locale. */
    moneyCents: (cents: number | null | undefined, currency?: string | null, fallback?: string) =>
      formatMoneyCents(cents, currency, locale, fallback),
    /** Format a MAJOR-unit amount under the resource currency + locale. */
    money: (amount: number | null | undefined, currency?: string | null, fallback?: string) =>
      formatMoney(amount, currency, locale, fallback),
  };
}
